import React, { useState, useRef, useEffect } from "react";
import {
    ButtonGroup,
    Col,
    Container,
    Dropdown,
    DropdownButton,
    Form,
    Row,
    Tab,
    Tabs,
} from "react-bootstrap";

//components
import ManageTableWithDynamicPagination from "../../Components/TableTemplate/ManageTableWithDynamicPagination";
import Navbar from "../../Components/Navbar/Navbar";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import EditModal from "../../Components/Modals/EditModal";
import ViewModal from "../../Components/Modals/ViewModal";

//css
import "./Manage.css";
import "../../Components/Navbar/Navbar.css";

import { branchesMockData } from "../../Helpers/mockData/mockData";
import {
    createBranch,
    deleteBranch,
    getAllBranches,
    searchBranch,
    updateBranch,
} from "../../Helpers/apiCalls/Manage/Branches";
import toast from "react-hot-toast";
import {
    toastStyle,
    refreshPage,
    isAdmin,
    formatDate,
    TokenExpiry,
    capitalizeFirstLetter,
} from "../../Helpers/Utils/Common";
import {
    faGaugeSimpleMed,
    faListNumeric,
} from "@fortawesome/free-solid-svg-icons";
import { validateWarehouse } from "../../Helpers/Validation/Manage/WarehouseValidation";
import InputError from "../../Components/InputError/InputError";
import ReactDatePicker from "react-datepicker";
import { setMinutes, setHours } from "date-fns";
import Moment from "moment";
import { getAllPriceLevels } from "../../Helpers/apiCalls/Manage/PriceLevels";
import { useNavigate } from "react-router-dom";
import { getAllBranchesPotato } from "../../Helpers/apiCalls/PotatoCorner/Purchases/purchaseOrderApi";
import {
    createBranchPotato,
    deleteBranchPotato,
    searchBranchPotato,
    updateBranchPotato,
} from "../../Helpers/apiCalls/PotatoCorner/Manage/Branches";
import {
    getAllBranchGroup,
    getAllBranchGroupPotato,
} from "../../Helpers/apiCalls/Manage/BranchGroupApi";
import {
    getAllInventoryGroup,
    getAllInventoryGroupPotato,
} from "../../Helpers/apiCalls/Manage/InventoryGroup";
import Footer from "../../Components/Footer/Footer";
import downloadIcon from "../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";

export default function Warehouses() {
    const [inactive, setInactive] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [option, setOption] = useState("Select");
    const [isClicked, setIsClicked] = useState(false);
    let navigate = useNavigate();
    const [addTo, setAddTo] = useState("MANGO MAGIC");

    // MODALS //
    // DELETE
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    // VIEW
    const [showViewBranchModal, setShowViewBranchModal] = useState(false);
    const handleShowViewBranchModal = () => setShowViewBranchModal(true);
    const handleCloseViewBranchModal = () => setShowViewBranchModal(false);

    // EDIT
    const [showEditBranchModal, setShowEditBranchModal] = useState(false);
    const handleShowEditBranchModal = () => setShowEditBranchModal(true);
    const handleCloseEditBranchModal = () => setShowEditBranchModal(false);

    // ADD
    const [showAddBranchModal, setShowAddBranchModal] = useState(false);
    const handleShowAddBranchModal = () => setShowAddBranchModal(true);
    const handleCloseAddBranchModal = () => {
        setAddTo("")
        setShowAddBranchModal(false);
    }

    const handleAddSelect = (e) => {
        setAddTo(e);
    };

    //API
    const [branchesData, setBranchesData] = useState([]);
    const [branchGroup, setBranchGroup] = useState([]);
    const [inventoryGroup, setInventoryGroup] = useState([]);
    const [filterConfig, setFilterConfig] = useState({
        name: "",
        is_franchise: "3",
        page: 1,
    });
    const [excelData, setExcelData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    const isInitialMount = useRef(true);
    const filterConfigKey = 'manage-warehouses-filterConfig';
    // useEffect(()=>{
    //     if(isInitialMount.current){
    //         isInitialMount.current = false;
    //         setFilterConfig((prev) => {
    //             // 
    //             if (window.localStorage.getItem(filterConfigKey) != null){
    //                 // 
    //                 handleTabSelect(JSON.parse(window.localStorage.getItem(filterConfigKey)).tab);
    //                 return JSON.parse(window.localStorage.getItem(filterConfigKey))
    //             } else {
    //                 return {...prev}
    //             }
    //         });
    //     } else {
    //         window.localStorage.setItem(filterConfigKey, JSON.stringify(filterConfig));
    //     }
    // }, [filterConfig])

    const [selectedRow, setSelectedRow] = useState({
        name: "",
        address: "",
        contact_person_no: "",
        phone_no: "",
        tin_no: "",
        bir_no: "",
        franchisee_name: "",
        franchisee_contact_no: "",
        contract_start: "",
        contract_end: "",
        opening_date: "",
        price_level: "",
        contact_person: "",
    });
    const [priceLevel, setPriceLevels] = useState([]);

    //ERROR HANDLING
    const [isError, setIsError] = useState({
        name: false,
        address: false,
        phone_no: false,
    });

    const [isErrorEdit, setIsErrorEdit] = useState({
        name: false,
        address: false,
        phone_no: false,
    });

    const [osStartTime, setOsStartTime] = useState(new Date());
    const [osEndTime, setOsEndTime] = useState(new Date());

    const [deliveryStartTime, setDeliveryStartTime] = useState(new Date());
    const [deliveryEndTime, setDeliveryEndTime] = useState(new Date());

    const [osStartTimeEdit, setOsStartTimeEdit] = useState(new Date());
    const [osEndTimeEdit, setOsEndTimeEdit] = useState(new Date());

    const [deliveryStartTimeEdit, setDeliveryStartTimeEdit] = useState(
        new Date()
    );
    const [deliveryEndTimeEdit, setDeliveryEndTimeEdit] = useState(new Date());

    const [addBranchData, setAddBranchData] = useState({
        name: "",
        address: "",
        phone_no: "",
        inventory_group_id: "",
        contact_person_no: "",
        monthly_rental_fee: "",
        tin_no: "",
        bir_no: "",
        franchisee_name: "",
        franchisee_contact_no: "",
        contract_start: "",
        contract_end: "",
        opening_date: "",
        price_level: "",
        contact_person: "",
        initial_drawer: "",
        os_startDate: "monday",
        os_endDate: "sunday",
        os_startTime: "",
        os_endTime: "",
        delivery_startDate: "monday",
        delivery_endDate: "sunday",
        delivery_startTime: "",
        delivery_endTime: "",
        is_franchise: "3",
    });

    const [editBranchData, setEditBranchData] = useState({
        id: "",
        name: "",
        address: "",
        phone_no: "",
        contact_person_no: "",
        inventory_group_id: "",
        monthly_rental_fee: "",
        tin_no: "",
        bir_no: "",
        franchisee_name: "",
        franchisee_contact_no: "",
        contract_start: "",
        contract_end: "",
        opening_date: "",
        price_level: "",
        contact_person: "",
        operation_schedule: "",
        delivery_schedule: "",
        is_franchise: "3",
        os_startDate: "",
        os_endDate: "",
        delivery_startDate: "",
        delivery_endDate: "",
    });

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditBranchData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleAddChange = (e) => {
        const { name, value } = e.target;
        setAddBranchData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    };

    const handleTabSelect = (tabKey) => {
        setFilterConfig((prev) => {
            return { ...prev, tab: tabKey };
        });
    };

    const xlsxHeaders =  [
        "BRANCH NAME",
        "ADDRESS",
        "PHONE NUMBER"
    ]

    //EXPORT 
    function handleExport() {
        const rows = excelData
        
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
        XLSX.writeFile(workbook, "Warehouses.xlsx", { compression: true });
    }

    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }
    

    async function searchBranches() {
        setTotalItems(0);
        setBranchesData([]);
        setShowLoader(true);
        const response = await searchBranch(filterConfig);
        if (response.data) {
            var result = response.data.data;
            var mangoBranches = result.map((branch) => {
                return {
                    type: "mango",
                    os_startDate: "",
                    os_endDate: "",
                    delivery_startDate: "",
                    delivery_endDate: "",
                    branch_name: branch.name,
                    address: branch.address,
                    phone_number: branch.contact_person_no || branch.phone_no,
                    initial_cash: branch.initial_drawer,
                    branch_type: branch.is_franchise === "0" ? "Company-owned" : branch.is_franchise === "1" ? "Franchise Branch" : "Others",
                    action_btn: ActionBtn(branch, "mango"),
                };
            });
            setBranchesData(mangoBranches);
            setTotalItems(response.data.size);
    
            var excel = mangoBranches.map((data) => {
                return {
                    branch_name: data.branch_name,
                    address: data.address,
                    phone_no: data.phone_number,
                };
            });
            setExcelData(excel);
        } else if (response.error) {
            TokenExpiry(response);
        }
        setShowLoader(false);
    }
    
    async function create() {
        if (validateWarehouse(addBranchData, setIsError, addTo)) {
            setIsClicked(true);
            const response = await createBranch(addBranchData, {
                osStartTime: osStartTime,
                osEndTime: osEndTime,
                deliveryStartTime: deliveryStartTime,
                deliveryEndTime: deliveryEndTime,
            });
            if (response.data) {
                toast.success(response.data.message, {style: toastStyle()});
                handleCloseAddBranchModal();
                // searchBranches();
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            }
            setIsClicked(false)
        }
    }

    async function handleDeleteWarehouse() {
        setIsClicked(true);
        const response = await deleteBranch(selectedRow.id);
        if (response) {
            if (response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setTimeout(() => refreshPage(), 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setIsClicked(false);
            }
        } else {
            toast.error(response.data.response, {
                style: toastStyle(),
            });
        }
    }

    async function editBranch() {
        if (validateWarehouse(editBranchData, setIsErrorEdit, addTo)) {
            setIsClicked(true);
            const response = await updateBranch(editBranchData, {
                osStartTime: osStartTimeEdit,
                osEndTime: osEndTimeEdit,
                deliveryStartTime: deliveryStartTimeEdit,
                deliveryEndTime: deliveryEndTimeEdit,
            });

            if (response.data) {
                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                setTimeout(() => refreshPage(), 1000);
            } else {
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
                setTimeout(() => refreshPage(), 1000);
            }
        }
    }

    //DROPDOWN
    function handleSelectChange(e, row, type) {
        setSelectedRow(row);
        // setEditBranchData(row);
        setEditBranchData((prevState) => ({
            ...prevState,
            ...row,
        }));
        if (e.target.value === "delete-branch") {
            handleShowDeleteModal();
        } else if (e.target.value === "edit-branch") {
            handleShowEditBranchModal();
        } else if (e.target.value === "view-branch") {
            handleShowViewBranchModal();
        } else {
            handleShowDeleteModal();
        }
    }

    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action form-select"
                id={row}
                onChange={(e) => handleSelectChange(e, row, type)}
                value={option}
            >
                <option defaulValue selected hidden>
                    Select
                </option>
                <option value="view-branch" className="color-options">
                    View
                </option>
                {isAdmin && (
                    <option value="edit-branch" className="color-options">
                        Edit
                    </option>
                )}
                {isAdmin && (
                    <option value="delete-branch" className="color-red">
                        Delete
                    </option>
                )}
            </Form.Select>
        );
    }

    //onEdit
    function handleOnEdit() {
        handleCloseViewBranchModal();
        handleShowEditBranchModal();
    }

    function renderBranchType(type) {
        switch (type) {
            case "0":
                return `BRANCH DETAILS (Company-owned branch)`;
            case "1":
                return `BRANCH DETAILS (Franchise branch)`;
            default:
                return `BRANCH DETAILS`;
        }
    }

    //API CALL

    useEffect(() => {
        searchBranches();
    }, [filterConfig, currentPage]);


    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"MANAGE"} 
                />
            </div>
            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> WAREHOUSES </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            name="name"
                            className="search-bar"
                            // onChange={handleFilterChange}
                            onKeyPress={(e) =>
                                e.key === ("Enter" || "NumpadEnter") &&
                                handleFilterChange(e)
                            }
                            placeholder="Search warehouse name..."
                        />
                    </Col>
                    <Col lg={2} className="mt-4 mt-lg-0">
                        <div className="PO-filters">
                        <button
                            className="add-btn"
                            onClick={handleShowAddBranchModal}
                        >
                            Add
                        </button>
                        </div>
                    </Col>
                </Row>
                <div className="tab-content">
                    <ManageTableWithDynamicPagination
                        tableHeaders={[
                            "BRANCH NAME",
                            "ADDRESS",
                            "PHONE NUMBER",
                            "ACTIONS",
                        ]}
                        headerSelector={[
                            "branch_name",
                            "address",
                            "phone_number",
                            "action_btn",
                        ]}
                        tableData={branchesData}
                        showLoader={showLoader}
                        withActionData={true}
                        // used in dynamic pagination
                        totalItems={totalItems}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        handlePageChange={handlePageChange}
                    />
                </div>
                <div className="mb-3" />
                <Row>
                    <Col lg={10} className="mt-3 mt-lg-0"></Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                    <div className="PO-filters">
                        <button
                            type="button"
                            className="primary-btn"
                            onClick={handleExport}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon} alt=""
                                ></img>
                            </span>
                            Download
                        </button>
                    </div>
                    </Col>
                </Row>
                <div className="mb-3" />
                <br /><br />
            </div>
            {/* MODALS */}
            <DeleteModal
                text="branch"
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onDelete={() => handleDeleteWarehouse()}
                isClicked={isClicked}
            />
            <AddModal
                title={`ADD WAREHOUSE`}
                type="branch"
                show={showAddBranchModal}
                onHide={handleCloseAddBranchModal}
                onSave={() => create()}
                isProceed={addBranchData.is_franchise === "1" ? true : false}
                isClicked={isClicked}
            >
                <div className="mt-3 ">
                    <Row className="nc-modal-custom-row mt-0">
                        <Col xs={12} lg={4}>
                            BRANCH NAME
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="name"
                                value={addBranchData.name}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.name}
                                message={"Branch name is required"}
                            />
                        </Col>
                        <Col xs={12} lg={4} className="mt-2 mt-lg-0">
                            ADDRESS
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="address"
                                value={addBranchData.address}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.address}
                                message={"Address is required"}
                            />
                        </Col>
                        <Col xs={12} lg={4} className="mt-2 mt-lg-0">
                            PHONE NUMBER
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="phone_no"
                                value={addBranchData.phone_no}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleAddChange(e)}
                                required
                            />
                            <InputError
                                isValid={isError.phone_no}
                                message={"Phone number is required"}
                            />
                        </Col>
                    </Row>
                </div>
            </AddModal>
            <EditModal
                title="WAREHOUSE"
                type="branch"
                show={showEditBranchModal}
                onHide={handleCloseEditBranchModal}
                onSave={() => editBranch()}
                isClicked={isClicked}
            >
                <div className="mt-3 ">
                    <Row className="nc-modal-custom-row mt-0">
                        <Col xs={12} lg={4}>
                            BRANCH NAME
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="name"
                                value={editBranchData.name}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleEditChange(e)}
                                required
                            />
                            <InputError
                                isValid={isErrorEdit.name}
                                message={"Branch name is required"}
                            />
                        </Col>
                        <Col xs={12} lg={4} className="mt-2 mt-lg-0">
                            ADDRESS
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="address"
                                value={editBranchData.address}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleEditChange(e)}
                                required
                            />
                            <InputError
                                isValid={isErrorEdit.address}
                                message={"Address is required"}
                            />
                        </Col>
                        <Col xs={12} lg={4} className="mt-2 mt-lg-0">
                            PHONE NUMBER
                            <span className="required-icon">*</span>
                            <Form.Control
                                type="text"
                                name="phone_no"
                                value={editBranchData.phone_no}
                                className="nc-modal-custom-input-edit"
                                onChange={(e) => handleEditChange(e)}
                                required
                            />
                            <InputError
                                isValid={isErrorEdit.phone_no}
                                message={"Phone number is required"}
                            />
                        </Col>
                    </Row>
                </div>
            </EditModal>
            <ViewModal
                withButtons
                show={showViewBranchModal}
                onHide={handleCloseViewBranchModal}
                onEdit={handleOnEdit}
            >
                <div className="mt-0">
                    <div className="col-sm-12 m-0 space">
                        <span className="custom-modal-body-title-branch-details">
                            {renderBranchType(selectedRow.is_franchise)}
                        </span>
                        <div className="mt-3 container-wrapper">
                            <Row className="nc-modal-custom-row-view">
                                <Col xl={3} className="nc-modal-custom-row-details">
                                    BRANCH NAME
                                    <Row className="nc-modal-custom-row">
                                        <Col> {selectedRow.name || "N/A"} </Col>
                                    </Row>
                                </Col>
                                <Col xl={6} className="nc-modal-custom-row-details">
                                    BRANCH ADDRESS
                                    <Row className="nc-modal-custom-row">
                                        <Col>
                                            {" "}
                                            {selectedRow.address || "N/A"}{" "}
                                        </Col>
                                    </Row>
                                </Col>
                                <Col className="nc-modal-custom-row-details">
                                    PHONE NUMBER
                                    <Row className="nc-modal-custom-row">
                                        <Col>
                                            {selectedRow.phone_no || "N/A"}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </ViewModal>
            <Footer/>
        </div>
    );
}
